var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgUsers = function SvgUsers(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.25C5.37665 2.25 3.25 4.37665 3.25 7C3.25 9.62335 5.37665 11.75 8 11.75C10.6234 11.75 12.75 9.62335 12.75 7C12.75 4.37665 10.6234 2.25 8 2.25ZM13.25 3C13.25 2.58579 13.5858 2.25 14 2.25C16.6234 2.25 18.75 4.37665 18.75 7C18.75 9.62335 16.6234 11.75 14 11.75C13.5858 11.75 13.25 11.4142 13.25 11C13.25 10.5858 13.5858 10.25 14 10.25C15.7949 10.25 17.25 8.79493 17.25 7C17.25 5.20507 15.7949 3.75 14 3.75C13.5858 3.75 13.25 3.41421 13.25 3ZM6 14.25C3.37665 14.25 1.25 16.3766 1.25 19C1.25 20.5188 2.48122 21.75 4 21.75H12C13.5188 21.75 14.75 20.5188 14.75 19C14.75 16.3766 12.6234 14.25 10 14.25H6ZM16 14.25C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H18C19.7949 15.75 21.25 17.2051 21.25 19C21.25 19.6904 20.6904 20.25 20 20.25H16C15.5858 20.25 15.25 20.5858 15.25 21C15.25 21.4142 15.5858 21.75 16 21.75H20C21.5188 21.75 22.75 20.5188 22.75 19C22.75 16.3766 20.6234 14.25 18 14.25H16Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Users.b2a765b2c6499325d1fd666a1f26abdb.svg";